import { render, staticRenderFns } from "./channelIdManage.vue?vue&type=template&id=69095014"
import script from "./channelIdManage.vue?vue&type=script&lang=js"
export * from "./channelIdManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports